import { render, staticRenderFns } from "./ProfileAppointmentList.vue?vue&type=template&id=7b130988&"
import script from "./ProfileAppointmentList.vue?vue&type=script&lang=js&"
export * from "./ProfileAppointmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports